import type { FileRouteTypes } from '@client/routeTree.gen';
import { ORG_ROLES, type Role } from '@shared/constants';

const CONSOLE_HOME_ROLES = new Set<Role>([
    ORG_ROLES.ORG_ADMIN,
    ORG_ROLES.USER,
    ORG_ROLES.SHARED_EDIT_USER,
    ORG_ROLES.TRAINING_MANAGER,
    // CUR-2675: Home, with the payment tasks the role is given.
    ORG_ROLES.ACCOUNTS,
]);

/** Choose a console landing page that at least one of the caller's console roles can access. */
export function getConsoleWorkspaceLanding(userRoles: Role[]): FileRouteTypes['to'] {
    if (userRoles.some((role) => CONSOLE_HOME_ROLES.has(role))) {
        return '/console/$orgId';
    }
    if (userRoles.includes(ORG_ROLES.USER_MANAGER)) {
        return '/console/$orgId/configuration';
    }
    if (userRoles.includes(ORG_ROLES.ATTESTATIONS_USER)) {
        return '/console/$orgId/attestations';
    }
    return '/console/$orgId';
}
